export default __webpack_public_path__ + "img/9a15cdd34af82ba4314f813a7d14ef74.png";